import { useState } from "react";
import { api } from "../lib/api";

/**
 * Bottone visibile quando la generazione PDF fallisce per LibreOffice mancante (HTTP 503).
 * Avvia l'auto-install lato backend e fa polling fino al completamento, poi richiama `onReady()`
 * per riprovare la richiesta originale.
 */
export function LibreOfficeInstallButton({ onReady }) {
  const [phase, setPhase] = useState("idle"); // idle | installing | error | done
  const [err, setErr] = useState("");

  const start = async () => {
    setPhase("installing"); setErr("");
    try {
      await api.post("/privacy/modelli/_libreoffice/install");
    } catch { /* ignore */ }
    // poll status
    const t0 = Date.now();
    while (Date.now() - t0 < 180000) {
      await new Promise(r => setTimeout(r, 3000));
      try {
        const s = await api.get("/privacy/modelli/_libreoffice/status");
        if (s.data?.installed) {
          setPhase("done");
          if (onReady) onReady();
          return;
        }
        if (s.data?.install_error) {
          setPhase("error");
          setErr(s.data.install_error);
          return;
        }
      } catch { /* ignore */ }
    }
    setPhase("error");
    setErr("Timeout: installazione non completata in 3 minuti.");
  };

  if (phase === "done") {
    return <div style={{ color: "#1b5e20", fontSize: 12, fontWeight: 700 }}>✅ LibreOffice installato. Riprovo...</div>;
  }
  if (phase === "installing") {
    return <div style={{ color: "#0d47a1", fontSize: 12, fontWeight: 700 }}>⏳ Installazione LibreOffice in corso (può richiedere 1-2 minuti)...</div>;
  }
  return (
    <div>
      <button onClick={start} data-testid="libreoffice-install-btn"
        style={{ padding: "6px 14px", background: "#2e7d32", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
        🔧 Installa LibreOffice ora
      </button>
      {phase === "error" && <div style={{ color: "#c62828", fontSize: 11, marginTop: 4 }}>Errore: {err}</div>}
    </div>
  );
}
